import React from "react";
import ReactApexChart  from "react-apexcharts";

const EarningChart = ({data}) => {

    const options = {
        series: [{
            name: "EXPECTED EPS",
            data: [5.4, 2, 3, 2]
        }, {
            name: "ACTUAL EPS",
            data: [13.4, 11, 8, 17]
        }],
        chart: {
            height: 350,
            type: 'scatter',
            toolbar: {
                show: false,
            }
        },
        xaxis: {
            tickAmount: 10,
            categories: ["Q4 2019", "Q1 2020", "Q2 2020", "Q3 2020"],
        },
        
        colors: ["#000", "#1BC5BD"]
    };

    return <ReactApexChart options={options} series={options.series} type="scatter"height="300"  />

}

export default EarningChart;